import React from 'react';
import PropTypes from 'prop-types';
import clsx from 'clsx';
import { addUtils } from '../class-name-helpers';
import { HeadingPara } from '../Headings';

const Card = ({ children, ...props }) => {
  const { utilClassNames, restProps } = addUtils(props);
  return (
    <article className={clsx('ss_card', utilClassNames)} {...restProps}>
      {children}
    </article>
  );
};

Card.propTypes = {
  children: PropTypes.node.isRequired,
};

const CardHeader = ({ children }) => (
  <header className="ss_card__header">
    <HeadingPara el="h2" myMd center>
      {children}
    </HeadingPara>
  </header>
);

CardHeader.propTypes = {
  children: PropTypes.node.isRequired,
};

const CardBody = ({ children, className, ...props }) => {
  const { utilClassNames, restProps } = addUtils(props);
  return (
    <div className={clsx('ss_card__body', utilClassNames)} {...restProps}>
      {children}
    </div>
  );
};

CardBody.propTypes = {
  children: PropTypes.node.isRequired,
  className: PropTypes.string,
};
CardBody.defaultProps = {
  className: '',
};

const CardFooter = ({ children }) => <footer className="ss_card__footer ss_my--lg">{children}</footer>;

CardFooter.propTypes = {
  children: PropTypes.node.isRequired,
};

Card.Header = CardHeader;
Card.Body = CardBody;
Card.Footer = CardFooter;

export default Card;
